import ErrorMessage from 'utils/ErrorMessage'

import authRequest from 'utils/authRequest'
import corporateRequest from 'utils/corporateRequest'
import studentRequest from 'utils/studentRequest'
import instituteRequest from 'utils/instituteRequest'
import SuccessMessage from 'utils/SuccessMessage'
export const setRolesList = data => {
  return {
    type: 'SET_ROLES_LIST',
    data,
  }
}

export const setSingleRoleDetails = data => {
  return {
    type: 'SET_SINGLE_ROLE_DETAILS',
    data,
  }
}

export const setEligibleDetails = data => {
  return {
    type: 'SET_ELIGIBLE_DETAILS',
    data,
  }
}

export const setRoleFloatDetails = data => {
  return {
    type: 'SET_ROLE_FLOAT_DETAILS',
    data,
  }
}

export const setCities = data => {
  return {
    type: 'SET_CITIES',
    data,
  }
}

export const setRoleCities = data => {
  return {
    type: 'SET_ROLE_CITIES',
    data,
  }
}

export const ApplyRole =
  (data, questionaire, successMessage) => async (dispatch, getState) => {
    let isCorporateRole = data?.rolePublishedBy !== 'INSTITUTE'
    const state = getState()
    const payload = {
      roleId: data.id,
      studentId: state?.auth?.studentId,
      corporateId: isCorporateRole ? data?.corporateId : data?.companyId,
      accessLevel: state?.studentData?.campusDetails?.instituteSubscription?.accessLevel,
    }

    try {
      const result = await studentRequest.post(`/students/role/apply`, payload)
      if (result?.status >= 200 && result?.status <= 300 && !questionaire) {
        successMessage && SuccessMessage('Applied Successfully')
        let rolesCopy = { ...state.rolesListData?.rolesList }
        if (rolesCopy?.result) {
          let index = rolesCopy?.result?.findIndex(
            val => payload.roleId === val.id
          )
          if (index != -1) {
            if (rolesCopy?.result[index]) {
              rolesCopy.result[index].jobRoleStudentMap[0].isApplied = 1

              dispatch(setRolesList(rolesCopy))
            }
          }
        }
      }

      return result
    } catch (error) {
      console.log('Error in publish corporate job role =>', error)
      ErrorMessage(
        error?.response?.data?.message || 'Error in Applying the job role'
      )
      return error?.response
    }
  }

export const RejectedRole = data => async (dispatch, getState) => {
  const state = getState()
  const payload = {
    roleId: data.id,
    studentId: state?.auth?.studentId,
  }

  try {
    const result = await studentRequest.post(`/students/role/reject`, payload)

    return result
  } catch (error) {
    console.log('Error in publish corporate job role =>', error)
    ErrorMessage(
      error?.response?.data?.message || 'Error in Applying the job role'
    )
    return error?.response
  }
}

export const SaveRole = payload => async (dispatch, getState) => {
  const state = getState()

  const data = {
    roleId: payload.id,
    studentId: state?.auth?.studentId,
    isSaved: payload?.isSaved,
  }
  try {
    const result = await studentRequest.post(`/students/role/save`, data)
    if (result?.status === 201) {
      if(payload?.isSaved)
      SuccessMessage('Saved Successfully')
      else
      SuccessMessage('UnSaved Successfully')

      let rolesCopy = { ...state.rolesListData?.rolesList }
      let index = rolesCopy?.result.findIndex(val => payload.id === val.id)
      if (index != -1) {
        if (rolesCopy?.result[index]) {
          rolesCopy.result[index].jobRoleStudentMap[0].isSaved =
            +payload.isSaved

          dispatch(setRolesList(rolesCopy))
        }
      }
    }

    return result
  } catch (error) {
    console.log('Error in publish corporate job role =>', error?.message)
    return error?.response
  }
}

export const getRolesList =
  ({
    page,
    sortValue,
    search,
    jobTypeLevel,
    jobType,
    minCTC,
    maxCTC,
    locationFilter,
    setLoading,
  }) =>
  async (dispatch, getState) => {
    setLoading(true)
    const state1 = getState()
    let orderBy = ''
    let pagekey = `&pageNo=${page}`
    let sortkey = ''
    if (sortValue === 'sort=minCompensation') {
      sortkey = '&sort=maxCompensation'
      orderBy = 'orderBy=asc'
    } else if (sortValue === 'sort=maxCompensation') {
      sortkey = '&sort=maxCompensation'
      orderBy = 'orderBy=desc'
    } else {
      sortkey = sortValue ? `&${sortValue}` : ''
    }

    const transformedData = jobTypeLevel?.map(item => {
      switch (item) {
        case 'ENTRY LEVEL':
          return 'ENTRY'
        case 'INTERNSHIP':
          return 'INTERN'
        case 'EXPERIENCE':
          return 'EXPERIENCED'
        default:
          return item
      }
    })
    let searchKey = search ? `&searchBy=${search}` : ''

    let min = minCTC != 0 ? minCTC * 100000 : 0
    let max = maxCTC * 100000
    let minKey = min ? `&minCTC=${min}` : ''
    let maxKey = max ? `&maxCTC=${max}` : ''

    let JTValue = ''
    let JTLValue =
      jobTypeLevel?.length > 0
        ? `&jobTypeLevels=${transformedData?.toString()}`
        : ''
    if (jobType?.length === 1) {
      if (jobType[0] === 'FULL TIME') {
        JTValue = 'jobType=FULL_TIME'
      }
      if (jobType[0] === 'PART TIME') {
        JTValue = 'jobType=PART_TIME'
      }
    }

    let JTKey = JTValue ? `&${JTValue}` : ''

    let locationKey =
      locationFilter?.length > 0 ? `&jobLocation=${locationFilter}` : ''
    try {
      const res = await corporateRequest.get(
        `/corporates/instituteAcceptedJobsforStudent/${state1?.auth?.studentId}/lists?${orderBy}&pageLimit=10${pagekey}${sortkey}${searchKey}${JTLValue}${JTKey}${minKey}${maxKey}${locationKey}`
      )

      dispatch(setRolesList(res?.data?.data))

      setLoading(false)
    } catch (error) {
      dispatch(setRolesList([]))
      setLoading(false)
      console.log('Error in Getting Jobs list', error)
    }
  }

export const getSingleRoleDetails =
  (corpID, roleID) => async (dispatch, getState) => {
    try {
      const res = await corporateRequest.get(
        `/corporates/${corpID}/jobs/${roleID}`
      )

      dispatch(setSingleRoleDetails(res?.data?.data))
    } catch (error) {
      console.log('Error in Getting Jobs list', error)
    }
  }

export const getRoleFloatDetails =
  ({ setLoading }) =>
  async (dispatch, getState) => {
    setLoading(true)

    const state1 = getState()

    try {
      const res = await studentRequest.get(
        `/students/roleFloatDetails/${state1?.auth?.studentId}`
      )
      dispatch(setRoleFloatDetails(res?.data?.data))
      setLoading(false)

      console.log('Role float list data fetched successfully')
    } catch (error) {
      setLoading(false)

      console.log('Error in Getting Role Float list', error)
    }
  }

export const updateRoleFloatDetails =
  (data, itemId) => async (dispatch, getState) => {
    const state1 = getState()

      try {
        const res = await studentRequest.put(
          `/students/roleFloatDetails/${state1?.auth?.studentId}?roleId=${itemId}`,
          data
        )
        return res
      } catch (error) {
        console.log('Error in updating Role Float Details', error)
        return error
      }
  }

export const getEligibleDetails =
  ({ roleID, setLoading }) =>
  async (dispatch, getState) => {
    setLoading(true)
    const state1 = getState()
   
      try {
        const res = await corporateRequest.get(
          `/corporates/${roleID}/${state1?.auth?.studentId}/eligibleDetails`
        )

        dispatch(setEligibleDetails(res?.data?.data))
        setLoading(false)
        console.log('Skills and location list data fetched successfully')
        return res?.data?.data

      } catch (error) {
        //dispatch(setEligibleDetails([]))
        setLoading(false)

        console.log('Error in Getting Skill and location list', error)
        return error
      }
  }

export const getCities =
  (query = 'currentPage=0') =>
  async (dispatch, getState) => {
    try {
      const info = await authRequest.get(`/cities?pageLimit=50&${query}`)
      dispatch(setCities(info?.data?.data))
    } catch (error) {
      console.log('Error in Role Data', error)
    }
  }

export const getRoleCities =
  ({ query = 'forJobLocations=true', setLoadingCity }) =>
  async (dispatch, getState) => {
    setLoadingCity(true)
    const state1 = getState()
    try {
      const info = await corporateRequest.get(
        `/corporates/instituteAcceptedJobsforStudent/${state1?.auth?.studentId}/lists?${query}`
      )
      dispatch(setRoleCities(info?.data?.data))
      setLoadingCity(false)
    } catch (error) {
      setLoadingCity(false)
      console.log('Error in Role Location List', error)
    }
  }


  export const getStudentRoleList = payload => async (dispatch, getState) => {
    const state = getState()

    try {
      const result = await corporateRequest.post(`/corporates/roleFloatedforStudent/${state?.auth?.studentId}/lists`, payload)
  
      return result
    } catch (error) {
      console.log('Error in publish corporate job role =>', error)
      ErrorMessage(
        error?.response?.data?.message || 'Error in Applying the job role'
      )
      return error?.response
    }
  }

  export const getCompTypeList = () => async (dispatch, getState) => {
    const state = getState()

    try {
      const result = await instituteRequest.get(`/institute/${state?.auth?.studentId}/compensationList`)

  console.log(result,'result')
      return result
    } catch (error) {
      console.log('Error in publish corporate job role =>', error)
      ErrorMessage(
        error?.response?.data?.message || 'Error in Applying the job role'
      )
      return error?.response
    }
  }


  export const getSkillLocationFilterData = () => async (dispatch, getState) => {
    const state = getState()
    const instituteId = state?.studentData?.studentDetails?.instituteCampusId
    let payload = {}
    try {
      const result = await corporateRequest.post(`/corporate/institute/${instituteId}/student/${state?.auth?.studentId}/ruleEngine`, payload)      
      return result
    } catch (error) {
      console.log('Error in publish corporate job role =>', error)
      ErrorMessage(
        error?.response?.data?.message || 'Error in Applying the job role'
      )
      return error?.response
    }
  }

  export const getStudentRuleSet = () => async (dispatch, getState) => {
    const state = getState()
    let payload = {}
    try {
      const result = await corporateRequest.post(`/corporates/student/${state?.auth?.studentId}/ruleEligibility`, payload)      
      return result
    } catch (error) {
      console.log('Error in publish corporate job role =>', error)
      ErrorMessage(
        error?.response?.data?.message || 'Error in Applying the job role'
      )
      return error?.response
    }
  }